/**
 * Inertia が FormData を組むときの配列フォーマット。
 *
 * Inertia の既定は indices（`tags[0]` / `marry_report_photos_attributes[0][key]`）だが、
 * このアプリは brackets（`tags[]` / `marry_report_photos_attributes[][key]`）に倒している。
 * indices にすると Rack が `tags[0]` をハッシュに組むため `permit(tags: [])` が空を返し、
 * MarryReportsController#event_params の `permitted[:tags] ||= []` と合わさって
 * 編集のたびにタグが全消去される（保存は成功するので無言のデータ欠損になる）。
 *
 * entrypoints/inertia.tsx の設定と、送信キー列を固定するテストの両方がここを参照する。
 * 片方だけ変えても気付けるように、値は必ずこの定数経由で使うこと。
 */
export const FORCE_INDICES_ARRAY_FORMAT_IN_FORM_DATA = false;

// 三項の "indices" 側は静的には到達しない（const がリテラル型 false に絞られるため）。
// 逆向き（書式文字列を正にして boolean を導出する）にすると、宣言型を
// `"brackets" | "indices"` と注釈しても TS が同じく絞り込むため、比較が TS2367
// 「重なりのない比較」になってコンパイルが通らない。つまみを1つに保つ形はこの向きだけ。
/** objectToFormData の第4引数に渡す形。上の設定から導出する。 */
export const FORM_DATA_ARRAY_FORMAT = FORCE_INDICES_ARRAY_FORMAT_IN_FORM_DATA ? "indices" : "brackets";
